




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class EyeIcon extends Vue {
  @Prop({ default: "open" }) variant!: string;

  get iconSrc() {
    if (this.variant === "open") {
      return require("@/assets/icons/eye-open.svg");
    }
    return require("@/assets/icons/eye-closed.svg");
  }
}
